import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "row justify-content-center" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "row justify-content-center" }
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicLineChart = _resolveComponent("BasicLineChart")!
  const _component_LineWithDataLabelsChart = _resolveComponent("LineWithDataLabelsChart")!
  const _component_SteplineChart = _resolveComponent("SteplineChart")!
  const _component_DashedChart = _resolveComponent("DashedChart")!
  const _component_SplineAreaChart = _resolveComponent("SplineAreaChart")!
  const _component_NegativeAreaChart = _resolveComponent("NegativeAreaChart")!
  const _component_BasicBarAreaChart = _resolveComponent("BasicBarAreaChart")!
  const _component_GroupedChart = _resolveComponent("GroupedChart")!
  const _component_BasicColumnAreaChart = _resolveComponent("BasicColumnAreaChart")!
  const _component_ColumnWithDataLabelsChart = _resolveComponent("ColumnWithDataLabelsChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4\"><h3 class=\"mb-0\">Apex Line Charts</h3><nav style=\"--bs-breadcrumb-divider:&#39;&gt;&#39;;\" aria-label=\"breadcrumb\"><ol class=\"breadcrumb align-items-center mb-0 lh-1\"><li class=\"breadcrumb-item\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><i class=\"ri-home-4-line fs-18 text-primary me-1\"></i><span class=\"text-secondary fw-medium hover\">Dashboard</span></a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"><span class=\"fw-medium\">Apex Charts</span></li></ol></nav></div>", 1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BasicLineChart)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LineWithDataLabelsChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SteplineChart)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DashedChart)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-12" }, [
        _createElementVNode("div", { class: "text-center mb-4" }, [
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/line-charts/",
            target: "_blank",
            class: "btn btn-primary py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Line Charts "),
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/",
            target: "_blank",
            class: "btn btn-success text-white py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Charts ")
        ])
      ], -1))
    ]),
    _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4\"><h3 class=\"mb-0\">Apex Area Charts</h3><nav style=\"--bs-breadcrumb-divider:&#39;&gt;&#39;;\" aria-label=\"breadcrumb\"><ol class=\"breadcrumb align-items-center mb-0 lh-1\"><li class=\"breadcrumb-item\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><i class=\"ri-home-4-line fs-18 text-primary me-1\"></i><span class=\"text-secondary fw-medium hover\">Dashboard</span></a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"><span class=\"fw-medium\">Apex Charts</span></li></ol></nav></div>", 1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_SplineAreaChart)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_NegativeAreaChart)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-12" }, [
        _createElementVNode("div", { class: "text-center mb-4" }, [
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/area-charts/",
            target: "_blank",
            class: "btn btn-primary py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Area Charts "),
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/",
            target: "_blank",
            class: "btn btn-success text-white py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Charts ")
        ])
      ], -1))
    ]),
    _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4\"><h3 class=\"mb-0\">Apex BRB Charts</h3><nav style=\"--bs-breadcrumb-divider:&#39;&gt;&#39;;\" aria-label=\"breadcrumb\"><ol class=\"breadcrumb align-items-center mb-0 lh-1\"><li class=\"breadcrumb-item\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><i class=\"ri-home-4-line fs-18 text-primary me-1\"></i><span class=\"text-secondary fw-medium hover\">Dashboard</span></a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"><span class=\"fw-medium\">Apex Charts</span></li></ol></nav></div>", 1)),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_BasicBarAreaChart)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_GroupedChart)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-lg-12" }, [
        _createElementVNode("div", { class: "text-center mb-4" }, [
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/bar-charts/",
            target: "_blank",
            class: "btn btn-primary py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Bar Charts "),
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/",
            target: "_blank",
            class: "btn btn-success text-white py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Charts ")
        ])
      ], -1))
    ]),
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4\"><h3 class=\"mb-0\">Apex Column Charts</h3><nav style=\"--bs-breadcrumb-divider:&#39;&gt;&#39;;\" aria-label=\"breadcrumb\"><ol class=\"breadcrumb align-items-center mb-0 lh-1\"><li class=\"breadcrumb-item\"><a href=\"#\" class=\"d-flex align-items-center text-decoration-none\"><i class=\"ri-home-4-line fs-18 text-primary me-1\"></i><span class=\"text-secondary fw-medium hover\">Dashboard</span></a></li><li class=\"breadcrumb-item active\" aria-current=\"page\"><span class=\"fw-medium\">Apex Charts</span></li></ol></nav></div>", 1)),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_BasicColumnAreaChart)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_ColumnWithDataLabelsChart)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-lg-12" }, [
        _createElementVNode("div", { class: "text-center mb-4" }, [
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/column-charts/",
            target: "_blank",
            class: "btn btn-primary py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Column Charts "),
          _createElementVNode("a", {
            href: "https://apexcharts.com/javascript-chart-demos/",
            target: "_blank",
            class: "btn btn-success text-white py-3 px-4 me-1 fs-16 fw-medium text-decoration-none d-inline-block"
          }, " View All Charts ")
        ])
      ], -1))
    ])
  ], 64))
}